export default __webpack_public_path__ + "static/imgCosmeticpng-c5ec77be816e5a23c6732acafe1e91a1.png";